module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Hi Rachel,")])]), _vm._v(" "), _c('p', {
    staticClass: "blocki"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I can’t believe they’re making me do this. We’re in the van already and it isn’t even light outside. I begged them to change their minds, but they said Dad’s new job is important to him and that families should support each other—not make each other give up the things they love. I don’t even think they’re listening to themselves or they wouldn’t have made me give up Florida. And you. I miss you already.")])]), _vm._v(" "), _c('p', {
    staticClass: "blocki"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Love,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockib"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tessa")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Rain batters the windshield of our ancient minivan, the wipers furiously working to keep the glass clear. ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("City lights fade to a blur in my tired eyes. We left Fort Myers on Thursday morning. Nineteen hours in a seat belt, four Twinkies, twenty-one old episodes of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Simpsons")]), _vm._v(", and one cramped hotel later we finally get here . . . Chicago. The Windy City.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My parents keep saying this place is going to be everything we ever needed but didn’t know existed. Whatever that means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our house was built in the late eighteen hundreds, you know. So of course there will be some work to do,” Dad says, loud enough so I can hear, but quiet enough not to wake my little brother, Jonah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom is nodding enthusiastically. “I know. But it’s so worth it. Think of all that original wood! And those high ceilings! It’s a dream.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I roll my eyes. It "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("isn’t")]), _vm._v(" a dream, but there’s no telling them that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The car swerves violently around something in the road, and I crane my neck to see what it was. Shadows dance in the darkness stretched out in front of us. “What was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a limb in the road. Everything’s fine. We’re alllllmost there,” Dad says in that voice he uses when he’s trying to lighten the mood. “You okay back there, honey?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I look up but can’t see his expression in the rearview ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("mirror. I’m kinda glad. If I could see it, he’d probably look wild and excited like he always does when he talks about moving here. About his new job.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Given that I just left behind my best friend, Rachel, a seventh-grade year that was going to be amazing, and my favorite drawing class, I’m not too interested in seeing that look right now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fine. Just a little nervous. We’re going to get there okay, right?” I ask as another small branch pings off our hood. Leaves are pinwheeling frantically through the air and landing on our windshield in a disgusting, wet mess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course we are, Tess. This is just a fall thunderstorm,” Dad answers, leaning forward even more. “Nothing like hurricane season back in Florida. Remember all the times we almost evacuated?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod but stay silent. Truth is, we did "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("almost")]), _vm._v(" evacuate a lot, but we never actually had to. It was warm there, too. Like the sun followed you around just to kiss the tops of your shoulders and lighten your hair. Based on the few times we’ve visited here to house-hunt, I know it feels different. Colder.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Mom reaches back, looking for me in the darkness. I grab her hand even though I still feel angry. Deep down I know it isn’t her fault. It isn’t anyone’s. When the Chicago Symphony Orchestra comes calling with ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("an opportunity, you answer. And my dad—the best violinist in all of Florida—was the guy they called to audition when the first chair opened up.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I glance at Jonah, who is still sound asleep in his car seat. Both of his arms are wound tightly around Reno, the wooden ventriloquist dummy he refuses to go anywhere without. I hate the way Reno looks at me. Like he’s watching me. Beady eyes, circus clothes, and a shock of black hair glued to wood . . . ugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jonah settles deeper into his car seat and lets out a soft moan. I have no idea how he’s sleeping through this disaster, but for a minute, I wish he weren’t. Maybe if he started crying, Dad would stop the van. Maybe if he threw up, we could at least slow down a little. Maybe, maybe, maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad sighs. “It’s taken us an hour since we hit the city limits, but according to my GPS, the house is just around this corner. This looks familiar, right, Lily?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it obviously looks different in the dark, but I think so,” Mom answers, a nervous laugh escaping her lips. Mom is the most positive person I know, but I think she’s just as scared about this move as me. Maybe even more.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("I get it. I have no idea how she’ll sell her paintings here or if she even can. There aren’t any tiny seaside art shops or nautical boutiques here . . . and I can’t ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("imagine people in Chicago paying big money for pictures of seagulls and turtles and waves.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The car hugs the next curve as we turn slowly onto a narrow, one-way street. This is the right block. Small black wrought iron fences wrap around the trees. Parking signs jut up from the cement every few feet. A giant, metallic birdhouse-looking thingy sits on the corner. Mom says it’s art, but I think it’s horrible. Art is soft, and pastel, and shaded . . . "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" metallic and sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is the right place,” I pipe up, unable to keep the disappointment from leaking into my voice. I remember this block well enough from the two times we came to see the house. Mom and Dad drooled over it. I smiled when I felt like crying because although my parents are excited, I know they feel guilty for dragging Jonah and me here. I can see it in the looks they give each other when they think I’m not paying attention. I might miss Florida and all, but I don’t want them to feel bad. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Life happens")]), _vm._v(", or so the bumper stickers say.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("“Finally!” Dad breathes out. He pulls the car onto the small patch of cement they keep calling a driveway and turns it off. The headlights stay on for a few seconds longer, fixed on the wooden garage door at the bottom of the slope. I remember hearing that it ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("leads into a parking spot in the basement. A drive-in basement.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So. Weird.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad twists around in his seat and squares his body off between Mom and me so he can talk to both of us. “Now remember, there’s just the bare bones in here right now. A few things the previous owners left in here to make our transition easier until the moving vans arrive tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom raises an eyebrow. “You mean, a few things that were too much of a hassle for them to move out. Right, Chris?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad tosses her a wink and a grin in response. I squint through the rain, wondering exactly what was left in this place. Hopefully nothing gross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom and I toss open our doors and make a run for it while Dad grabs Jonah from his car seat. I can hear my brother screeching from my spot on the front porch. The whole neighborhood probably thinks there’s a wild animal on the loose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reno’s knobby wooden knees clank together as Dad jogs through the gauzy sheets of rain. He sets Jonah down on the top step, then rakes a hand through his dripping-wet hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” he says, fishing in his pocket for something. Hopefully the keys because it’s freezing out here.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“Well,” Mom echoes, taking a tearstained Jonah by the hand. He’s clutching Reno like a life preserver. “This is it!”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Our new house is huge. Three floors and built like Fort Knox. Apparently Chicagoans call it a graystone, which is really just a fancy name for a cement house. I run a finger over the brick, shivering at how cold and unwavering it is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in Florida, nothing was brick. Nothing was really this gray, either. We had houses that were blue, green, and even yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I let my eyes settle on one of the second-floor windows. That room is mine. Mom picked it out during the house tour, started talking crazy fast about decorations and colors and how much I’d love the view. All I saw then was an old room with warped wooden floors and cracked paint. All I see now is ugly gray brick and the dark, gaping eye of a window. It’s watching me, this house. Waiting to swallow me whole in its cobwebby corners and creaky closets.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 60
// module chunks = 0